import {
    addTodo,
    setSubject,
    setLinkedEmailEntity,
    setExtractionId,
} from '../actions/quickAddActions';
import { addTodosToFolderView, todosAdded } from '../actions/todoFolderViewActions';
import { getGuid } from 'owa-guid';
import { orchestrator } from 'satcheljs';
import { createTodo, LinkedEmail } from 'owa-todo-types';
import { Datapoints } from '../datapoints';
import { logUsage } from 'owa-analytics';
import handleCreateTodos from './handleCreateTodos';
import { now } from 'owa-datetime';

export const addTodoOrchestrator = orchestrator(addTodo, async actionMessage => {
    const linkedEmail: LinkedEmail = actionMessage.linkedEmailEntity;

    const todo = createTodo({
        Id: getGuid(),
        Subject: actionMessage.subject,
        OrderDateTime: now(),
        LinkedEmail: linkedEmail,
    });
    addTodosToFolderView([todo], false /* deleteAll */, true /* addToFront */);

    // Reset the subject and the linked email Id
    setSubject('');
    setLinkedEmailEntity(null);
    setExtractionId(null);

    // Kick off the add todo action.
    await handleCreateTodos([todo], actionMessage.folderId);

    //log SmartTask success metrics
    if (linkedEmail && linkedEmail.EntitySubtype === 'suggestion_from_email') {
        const datapoint = Datapoints.todoItemActionCreatedFromTaskSuggestion();
        logUsage(
            datapoint.name,
            datapoint.customData(actionMessage.extractionId),
            datapoint.options
        );
    }

    // reload the folder irrespective of success.
    todosAdded();
});
